import React, { createElement, useState } from 'react'
import PropTypes from 'prop-types'
import { handleLinkClick, handleOpenModel } from 'src/lib/utils'
import { useNavigate } from 'react-router-dom'
import CustomModal from './CustomModal'
import Helpline from 'src/pages/Helpline'
import VideoPlayer from './layouts/VideoPlayer'
import TermsOfUse from 'src/pages/TermsOfUse'
export default function SetInnerHtml({ tag, className, id, style, content }) {
  const navigate = useNavigate()
  const [showModal, setShowModal] = useState(false)
  const [videoShow, setVideoShow] = useState(false)
  const [modalContent, setModalContent] = useState(null)
  const handleClick = (e) => {
    handleLinkClick(e, navigate)
    const dataTarget = handleOpenModel(e, setShowModal, setVideoShow)
    if (dataTarget) {
      if (['#contactModal', '#termsModal'].includes(dataTarget)) {
        setShowModal(true)
        if (dataTarget === '#contactModal') {
          setModalContent(<Helpline onHide={() => setShowModal(false)} />)
        } else if (dataTarget === '#termsModal') {
          setModalContent(<TermsOfUse className="container-fluid" />)
        }
      } else if (['#myvideoModal', '#myvideoModal1'].includes(dataTarget)) {
        let index = 0
        if ('#myvideoModal' === dataTarget) index = 1
        setVideoShow(true)
        setModalContent(<VideoPlayer onHide={() => setVideoShow(false)} videoIndex={index} />)
      }
    }
  }
  return (
    <>
      {createElement(tag, {
        className,
        id,
        style,
        dangerouslySetInnerHTML: { __html: content },
        onClick: handleClick,
      })}
      {showModal && (
        <CustomModal
          show={showModal}
          onHide={() => setShowModal(false)}
          bodyContent={modalContent}
          size={'xl'}
        />
      )}
      {videoShow && (
        <CustomModal
          show={videoShow}
          onHide={() => setVideoShow(false)}
          bodyContent={modalContent}
          size="xl"
          className="video-modal"
        />
      )}
    </>
  )
}
SetInnerHtml.propTypes = {
  tag: PropTypes.string.isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
  style: PropTypes.any,
  content: PropTypes.string.isRequired,
}
